export function Menu() {
    document.addEventListener('DOMContentLoaded', function() {
        const megaMenus = document.querySelectorAll('.mega-menu');
        const menuItems = document.querySelectorAll('.menu-item-has-children > a');
        const header = document.querySelector('.site-header');

        // Crea overlay
        const overlay = document.createElement('div');
        overlay.className = 'menu-overlay d-none';
        document.body.appendChild(overlay);

        const hideAllMegaMenus = () => {
            megaMenus.forEach(m => m.classList.add('d-none'));
            menuItems.forEach(link => link.setAttribute('aria-expanded', 'false'));
            overlay.classList.add('d-none');
            header.classList.remove('full-color');
        };

        // 1) Tutti i mega-menu nascosti all’avvio
        megaMenus.forEach(menu => menu.classList.add('d-none'));

        // 2) Click sulle voci padre
        if (menuItems.length > 0) {
            menuItems.forEach(link => {
                // aria per accessibilità
                link.setAttribute('aria-expanded', 'false');
                link.setAttribute('aria-haspopup', 'true');

                link.addEventListener('click', function(e) {
                    // se è un '#', non navigare
                    if (this.getAttribute('href') === '#') e.preventDefault();

                    const megaMenu = this.parentElement.querySelector('.mega-menu');
                    if (!megaMenu) return;

                    const willOpen = megaMenu.classList.contains('d-none');

                    // Chiudi tutti gli altri
                    megaMenus.forEach(m => { if (m !== megaMenu) m.classList.add('d-none'); });
                    menuItems.forEach(a => { if (a !== this) a.setAttribute('aria-expanded', 'false'); });

                    // Toggle quello cliccato
                    if (willOpen) {
                        megaMenu.classList.remove('d-none');
                        overlay.classList.remove('d-none');
                        this.setAttribute('aria-expanded', 'true');
                        header.classList.add('full-color'); 
                    } else {
                        megaMenu.classList.add('d-none');
                        this.setAttribute('aria-expanded', 'false');
                        if ([...megaMenus].every(m => m.classList.contains('d-none'))) {
                            overlay.classList.add('d-none');
                            header.classList.remove('full-color');
                        }
                    }
                });
            });
        }

        // 3) Click fuori (incluso overlay) → chiudi tutto
        document.addEventListener('click', function(e) {
            if (!e.target.closest('.menu-item-has-children')) {
                hideAllMegaMenus();
            }
        });
        overlay.addEventListener('click', hideAllMegaMenus);

        // 4) ESC per chiudere
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') hideAllMegaMenus();
        });
    });
}